"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignPost = void 0;
const react_1 = __importStar(require("react"));
const controls_1 = require("../controls");
const helpers_1 = require("../helpers");
const Icon_1 = require("../Icon");
const icons_1 = require("../icons");
const TextInfo_1 = require("./components/TextInfo/TextInfo");
const SignPostPositions_1 = require("./helpers/SignPostPositions");
const ViewIcons_1 = require("./helpers/ViewIcons");
const SignPost_styles_1 = require("./SignPost.styles");
const SignPostView_1 = require("./types/SignPostView");
const StackView_1 = require("../StackView");
exports.SignPost = (0, helpers_1.createUIElement)('SignPost', (_a, ref) => {
    var { className, initialShownState, width, text, view = SignPostView_1.SIGN_POST_VIEW.info, color, positions = SignPostPositions_1.DEFAULT_POSITIONS, children, iconSrc, icon, whitespace, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "initialShownState", "width", "text", "view", "color", "positions", "children", "iconSrc", "icon", "whitespace", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const rootRef = (0, react_1.useRef)(null);
    const controlRef = ref || rootRef;
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'control', [initialDataSelectorId]);
    const useMaxWidth = (0, react_1.useMemo)(() => typeof (text || children) === 'string' && !width, [children, text, width]);
    const textInfo = (0, react_1.useMemo)(() => text || children, [children, text]);
    const [control] = (0, controls_1.useDropdown)({
        ref: controlRef,
        initialActiveState: initialShownState,
        popoverConfig: positions,
        renderControl: ({ button }) => {
            return (react_1.default.createElement(SignPost_styles_1.StyledSignPostButton, Object.assign({}, rest, { ref: button.ref, style: style, "data-selector-id": dataSelectorId, onClick: onClick, onMouseDown: (e) => {
                    button.onMouseDown(e);
                    onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                }, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, type: "button", className: (0, helpers_1.cn)('vm-SignPost', className) }),
                react_1.default.createElement(Icon_1.Icon, { src: icon ||
                        iconSrc ||
                        ViewIcons_1.VIEW_ICONS[view] ||
                        ViewIcons_1.VIEW_ICONS[SignPostView_1.SIGN_POST_VIEW.info] })));
        },
        renderPopover: ({ popover, actions }) => (react_1.default.createElement(SignPost_styles_1.StyledSignPost, Object.assign({}, popover, { width: width, view: view, color: color, useMaxWidth: useMaxWidth }),
            react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.start, distribution: StackView_1.STACK_DISTRIBUTION.between },
                react_1.default.createElement(TextInfo_1.TextInfo, { whitespace: whitespace }, textInfo),
                react_1.default.createElement(SignPost_styles_1.StyledSignPostButtonClose, { type: "button", onClick: () => actions.hide() },
                    react_1.default.createElement(Icon_1.Icon, { size: Icon_1.ICON_SIZES.m, "data-selector-id": 'close', src: react_1.default.createElement(icons_1.CloseIcon, null) })))))
    });
    return control;
});
//# sourceMappingURL=SignPost.js.map